import { useMutation } from '@tanstack/react-query';
import { AGGREGATE_NAMES, LOAN_REQUEST_COMMANDS } from 'cpool-constants';
import type { SchemaLoanRequestResolver_Get } from 'cpool-tables/backend-resolvers';
import type { UseFormGetValues } from 'react-hook-form';

import type { SetSubmitStatus } from '../../../context/BankCreditRequestFormContext';
import type { SchemaCreditRequestForm } from '../NewCreditRequest/schemas/creditRequestForm.schema';
import { buildOfferRequestConditionsPayload } from '../utils/buildOfferRequestConditionsPayload';
import { APICommunicator } from '~/api/APICommunicator';

export const useUpdateOfferRequestConditionsMutation = (lead: SchemaLoanRequestResolver_Get) => {
    return useMutation({
        mutationFn: ({
            getValues,
        }: {
            getValues: UseFormGetValues<SchemaCreditRequestForm>;
            setSubmitStatus: SetSubmitStatus;
        }) =>
            APICommunicator.sendCommand({
                aggregateId: lead.id,
                aggregateName: AGGREGATE_NAMES.LOAN_REQUEST,
                commandName: LOAN_REQUEST_COMMANDS.updateOfferRequestConditions,
                payload: buildOfferRequestConditionsPayload({ coApplicantHidden: lead.coApplicantHidden, getValues }),
            }),
        onError: (error, variables) => {
            variables.setSubmitStatus({ error, saved: false });
        },
        onSuccess: ({ position }, variables) => {
            // this will setQueryPosition and invalidateQueries
            variables.setSubmitStatus({ position, saved: true });
        },
    });
};
